module.exports = __webpack_public_path__ + "static/media/presss.05644322.jpg";